import React from "react";

const TShirt3 = ({ fillColor = "#FFDFC4", strokeColor = "#000000" }) => (
	<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 408 1220">
		<defs>
			<style>
				{`.cls-1 { fill: none; } .cls-2 { stroke-miterlimit: 10; }`}
			</style>
		</defs>
		<title>Base</title>
		<g id="cadre">
			<rect className="cls-1" width={408} height={1220} />
		</g>
		<g id="base">
			<path
				id="frame_1"
				data-name="frame 1"
				className="cls-2"
				fill={fillColor} // 👈 Apply dynamic fill color
				stroke={strokeColor} // 👈 Apply dynamic stroke color
				d="M989.5,976.5s118,47,176-7c-5-51,0-147,0-147s18-3,27-17c-4-17-16-74-21-81s-64.34-42.77-64.34-42.77-.66,29.77-15.66,32.77-40,1.45-56-32.77c-42,5.77-77,20.77-81,25.77s-40,100-42,105c18.82,23.94,40.72,35.35,65,37l7-13s12,56,12,67S989.5,976.5,989.5,976.5Z"
				transform="translate(-878.5 -427.5)"
			/>
		</g>
	</svg>
);

export default TShirt3;
